import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetEndOfMonthTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const endOfMonthTypes = useQuery(
    ['getEndOfMonthTypes'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService?.getApiAwardApiAppStatusDropdownAppServicesEndOfMonthTypes()
      );
    },
    {
      select: (data) => {
        // Define the order array
        const orderArray = ['Null', 'PriorMonth', 'CurrentMonth'];

        // Sort the data based on the orderArray
        const sortedData = [...(data ?? [])].sort((a, b) => {
          const aSystem = a.systemName?.toLowerCase() ?? 'null';
          const bSystem = b.systemName?.toLowerCase() ?? 'null';

          return orderArray.indexOf(aSystem) - orderArray.indexOf(bSystem);
        });

        return sortedData?.map((item) => {
          return {
            label: `${item.displayName}`,
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return endOfMonthTypes;
};

export default useGetEndOfMonthTypes;
